import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { Feature, FeatureNames, FeaturePropertyKey, IsNumberValueProperty } from '@vi-iot/client';

import { InstallationFeaturesStore } from '@store';

import { FeaturesDetailsOverlayTypeEnum } from '../installation-overlay.model';

@Component({
  selector: 'app-energy-cockpit-panel',
  templateUrl: './energy-cockpit-panel.component.html',
  styleUrls: ['./energy-cockpit-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnergyCockpitPanelComponent implements OnInit {
  readonly featurePropertyKey = FeaturePropertyKey;
  availableOverlays = FeaturesDetailsOverlayTypeEnum;

  cumulativeProduced$: Observable<Feature<IsNumberValueProperty, never>>;
  cumulativePurchased$: Observable<Feature<IsNumberValueProperty, never>>;
  cumulativeSold$: Observable<Feature<IsNumberValueProperty, never>>;

  @Input() deviceSelectId: string;
  @Input() deviceId: string;

  constructor(private installationFeaturesStore: InstallationFeaturesStore) {}

  ngOnInit(): void {
    this.cumulativeProduced$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.powerCumulativeProduced,
      this.deviceId
    );
    this.cumulativePurchased$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.powerCumulativePurchased,
      this.deviceId
    );
    this.cumulativeSold$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.powerCumulativeSold,
      this.deviceId
    );
  }
}
